import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import TodayIcon from '@mui/icons-material/Today';

export const NAVIGATION_ITEMS = {
  COMPLETED: {
    icon: <TaskAltIcon />,
    label: 'Completed meetings',
    link: 'completed',
  },
  DASHBOARD: {
    icon: <DashboardIcon />,
    label: 'Dashboard',
    link: 'dashboard',
  },
  DECLINED: {
    icon: <CancelIcon />,
    label: 'Declined',
    link: 'declined',
  },
  INVITED: {
    icon: <MarkEmailUnreadIcon />,
    label: 'Awaiting response',
    link: 'invited',
  },
  INVITES: {
    icon: <ChecklistIcon />,
    label: 'To invite',
    link: 'invite',
  },
  SCHEDULED: {
    icon: <EventAvailableIcon />,
    label: 'Booked For',
    link: 'scheduled',
  },
  TODAY: {
    icon: <TodayIcon />,
    label: 'Today',
    link: 'today',
  },
  UNCONTACTABLE: {
    icon: <ReportProblemIcon />,
    label: 'Uncontactable',
    link: 'uncontactable',
  },
};
